<template>
   <div id="specialTopic">
    <div class="banner">
        <div class="bannerImg" :class="'bannerImg'+viewId"></div>
    </div>
    <component :is="Comname" :visible.sync= "show" :viewId="viewId"></component>
   </div>
</template>

<script>
export default {
  computed: {
    Comname () {
      let queryName = this.$route.params.name ? this.$route.params.name : ''
      return () => import('./components/' + queryName + '.vue')
    },
    nowName () {
      let queryName = this.$route.params.name ? this.$route.params.name : ''
      return queryName
    }
  },
  created () {
    this.viewId = this.$route.params.id ? this.$route.params.id : ''
  },
  data () {
    return {
      show: true,
      srcImg: '',
      viewId: '',

      swiperOptionBanner: {
        direction: 'horizontal',
        loop: true,
        observer: true,
        observeParents: true,
        initialSlide: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  methods: {

  },
  mounted () {

  }

}
</script>

<style lang="scss" scoped>
#specialTopic{
  display: inline-block;
  font-size: 0;
  margin: 0;
  padding: 15px;
  background: #f5f5f5;
  width: 100vw;
  .banner{
    position: relative;
    margin-bottom: 25.5px;
    .swiperBanner{
      display: inline-block;
      width: calc(100vw - 30px);
      height: 180.5px;
      border-radius: 10px;
      .swiper-slide{
        width: 100%;
        .swiperItem{
          width: 100%;
          height: 100%;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
    .swiper-pagination{
      left: 0;
      right: 0;
      margin: 0 auto;
      bottom: 10px;
      >>> .swiper-pagination-bullet{
        width: 5px;
        height: 5px;
        opacity: 1;
        margin-right: 5px;
        background: #ffffff;
      }
      >>> .swiper-pagination-bullet-active{
        background: #c41335;
      }
    }
    .bannerImg{
      display: inline-block;
      width: calc(100vw - 30px);
      background: url("./images/banner01.png");
      height: 180.5px;
      border-radius: 10px;
    }
    .bannerImg01{
      background: url("./images/banner01.png");

    }.bannerImg02{
      background: url("./images/banner02.png");
    }.bannerImg03{
      background: url("./images/banner03.png");
    }.bannerImg04{
      background: url("./images/banner04.png");
    }
    .bannerImg{
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

        //       <swiper class="swiperBanner" v-if="bannersData.length >= 1" :options="swiperOptionBanner" ref="swiperBanner">
        //   <!-- slides -->
        //   <swiper-slide v-for="(value,index) in bannersData" :key="index">
        //     <div :class="value.h5_ad_url" :style="{backgroundImage:'url('+value+')'}"></div>
        //   </swiper-slide>
        // </swiper>
        // <div class="swiper-pagination" slot="pagination"></div>
}
</style>



// WEBPACK FOOTER //
// src/view/app_specialTopic/index.vue